export default __webpack_public_path__ + "static/media/distillation.6a90cdf2.png";